// import "material-design-icons-iconfont/dist/material-design-icons.css";
// import "typeface-roboto/index.css";
import colors from "vuetify/es5/util/colors";
import Vue from "vue";
import store from "@/store";
import "vuetify/dist/vuetify.min.css";
import Vuetify from "vuetify";

const themeColor = store.state.ui.themeColor;

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: colors[themeColor].base,
    secondary: colors[themeColor].lighten2,

    error: colors.red.base,
    info: colors.blue.base,
    success: colors.green.base,
    warning: colors.orange.base
  }
});
